import Cookies from "js-cookie";
import React from "react";
import Avatar from "react-avatar";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, MenuItem, MenuButton } from '@szhsin/react-menu';
import "./topbar.scss";
import { useModalMain } from "../../../../contexts/modal";
import { CreateOrder } from "../../../../components/modal-forms/create-order";
import MedicineForm from "../../../../components/MedicinePicker/MedicineForm";
import CreateUserWithPatient from "../../../../components/modal-forms/create-user/CreateUserWithPatient";
import { CreateUser } from "../../../../components/modal-forms/create-user";
import { AiOutlineUsergroupAdd, AiOutlineUser } from "react-icons/ai"
import { GiMedicines } from "react-icons/gi"
import { ImCart } from "react-icons/im"
import { ROLES } from "../../../../utils/constants";
import { MdDeliveryDining } from "react-icons/md";
import GetServiceability from "../../../../components/modal-forms/get-servicability/GetServicability";
import { MdFileUpload, MdPostAdd } from "react-icons/md";
import UploadFilesLSQ from "../../../../components/modal-forms/upload-files-lsq/UploadFilesLSQ";
import ConsoleSwitcher from "../../../../v2/components/ConsoleSwitcher";

function TopBar() {
    const [name, setName] = React.useState("John Doe");

    const [buttonLabels, setButtonLabels] = React.useState(["Create User"]);
    const history = useLocation();
    React.useEffect(() => {
        Cookies.get("user") && setName(JSON.parse(Cookies.get("user")).name);
    }, [Cookies.get("user")]);

    React.useEffect(() => {
        if (history.pathname.includes("orders")) {
            return setButtonLabels(["Create Order", "Create User", "Create user with patient", "Get servicability", "Upload Files LSQ"])
        }
        switch (history.pathname) {
            case "/medicine-master":
                return setButtonLabels(["Add New Medicine", "Create User", "Create user with patient", "Get servicability", "Upload Files LSQ"]);
            case "/quotations":
                return setButtonLabels(["Create User", "Create user with patient", "Get servicability", "Upload Files LSQ", "Create quotation"]);
            default:
                return setButtonLabels(["Create User", "Create user with patient", "Get servicability", "Upload Files LSQ"]);
        }
    }, [history.pathname]);

    function OpenModal(buttonLabel) {
        switch (buttonLabel) {
            case "Create Order":
                return CreateOrder;
            case "Add New Medicine":
                return MedicineForm;
            case "Create user with patient":
                return CreateUserWithPatient;
            case "Create User":
                return CreateUser;
            case "Get servicability":
                return GetServiceability;
            case "Upload Files LSQ":
                return UploadFilesLSQ;
        }
    }

    const TOPBAR_BUTTONS_ROLE_MAP = {
        "Create User": [ROLES.ADMIN, ROLES.PHARMACIST, ROLES.SUPER_ADMIN, ROLES.SUPPORT, ROLES.SUPER_SUPPORT],
        "Create user with patient": [ROLES.ADMIN, ROLES.PHARMACIST, ROLES.SUPER_ADMIN, ROLES.SUPPORT, ROLES.SUPER_SUPPORT],
        "Create Order": [ROLES.ADMIN, ROLES.PHARMACIST, ROLES.SUPER_ADMIN],
        "Add New Medicine": [ROLES.ADMIN, ROLES.PHARMACIST, ROLES.SUPER_ADMIN],
        "Get servicability": [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SUPER_SUPPORT, ROLES.SUPPORT],
        "Upload Files LSQ": [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SUPER_SUPPORT, ROLES.SUPPORT],
        "Create quotation": [ROLES.ADMIN, ROLES.PHARMACIST, ROLES.SUPER_ADMIN, ROLES.SUPER_SUPPORT],
    }

    // Every other topbar button opens a modal. This one is a page, so the click
    // handler needs a route rather than a form component.
    const TOPBAR_BUTTON_ROUTES = {
        "Create quotation": "/quotation/create",
    }

    const roles = Cookies.get("roles") && JSON.parse(Cookies.get("roles"))

    const { openModal } = useModalMain()
    const navigate = useNavigate()
    return (
        <div className="topbar-container">
            <div className="px-4 topbar-greetings rounded-t-xl">
                <div className="flex flex-row gap-2">
                    {
                        buttonLabels.map((label) => {
                            return TOPBAR_BUTTONS_ROLE_MAP[label].some(role => roles && roles.includes(role)) && <button
                                key={label}
                                className="bg-elm-500 text-white-50 px-4 py-3 rounded-2xl font-sans text-md font-semibold  flex justify-center gap-2"
                                onClick={() => {
                                    const route = TOPBAR_BUTTON_ROUTES[label];
                                    return route ? navigate(route) : openModal(OpenModal(label), "Add User", {}, false);
                                }}>
                                {label}
                                {
                                    label === 'Create user with patient' ?
                                        <AiOutlineUsergroupAdd className="text-2xl" />
                                        : label === 'Create User' ?
                                            <AiOutlineUser className="text-xl" />
                                            : label === 'Add New Medicine' ?
                                                <GiMedicines className="text-xl" />
                                                : label === "Create Order" ?
                                                    <ImCart className="text-xl" />
                                                    : label === "Get servicability" ?
                                                        <MdDeliveryDining className="text-xl" />
                                                        : label === "Upload Files LSQ" ?
                                                            <MdFileUpload className="text-xl" />
                                                            : label === "Create quotation" ?
                                                                <MdPostAdd className="text-xl" />
                                                                : null

                                }
                            </button>
                        })
                    }

                    {/*
                        Rendered outside the buttonLabels.map() above deliberately: that
                        list is rebuilt per-pathname by the switch in the effect, so
                        adding this to it would mean repeating it in all four branches
                        and remembering to add it to the fifth. This is a navigation
                        affordance that should be present on every page, not a
                        page-specific action.

                        Replaces the separate "OPS Console" and "Pharmacy Console"
                        buttons that used to sit here. Those were one-way links with no
                        sense of where you already were -- an admin saw both and no
                        indication of the current console. The switcher renders every
                        console the user is entitled to and marks the active one; it
                        hides itself entirely when there is only one.
                    */}
                    <ConsoleSwitcher />
                </div>


                {/* Menu */}
                <Menu transition menuStyle={{ marginRight: "10px" }} menuButton={<MenuButton>
                    <div className="flex items-center gap-3">
                        <h1 className="font-bold font-sans">Hi, {name}</h1>
                        <Avatar
                            size="40"
                            facebook-id="invalidfacebookusername"
                            src="https://static.vecteezy.com/system/resources/previews/007/224/856/original/flat-doctor-avatar-for-website-chat-window-vector.jpg"
                            className="rounded-full"
                        />
                    </div>
                </MenuButton>}>
                    <MenuItem key="btn1">
                        <button onClick={() => {
                            Cookies.remove("user");
                            Cookies.remove("token");
                            Cookies.remove("refresh_token")
                            Cookies.remove("token_expires_at")
                            window.location.reload();
                        }} className="logoutbtn">Logout
                        </button>
                    </MenuItem>
                </Menu>
            </div>
        </div>
    );
}

export default TopBar;
